import {useTranslation} from 'react-i18next';
import {ButtonBox, EmptyBox, EmptyBoxTitle} from './styled';

type Props = {onClick?: () => void};
export const EmptyGuestItem = ({onClick}: Props) => {
  const {t} = useTranslation();

  return (
    <EmptyBox onClick={onClick} role="button">
      <EmptyBoxTitle>{t('add_guest')}</EmptyBoxTitle>
      <ButtonBox name="addItem" title="Add" size={24} />
    </EmptyBox>
  );
};
